module.exports = __webpack_public_path__ + "static/media/payments-icon.fd0584cb.svg";